import {createElement} from 'react';
import {convertNlToBr} from './convertNlToBr';

export const convertToLink = (text: string) => {
  const regex = /(https?:\/\/[\w!?/+\-_~=;.,*&@#$%()'[\]]+)/;
  const convertedText = convertNlToBr(text);
  return convertedText.map((item) => {
    if (typeof item !== 'string') {
      return item;
    }

    return item.split(regex).map((line, i) => {
      if (regex.test(line)) {
        return createElement(
          'a',
          {
            key: i,
            target: '_blank',
            href: line,
            className:
              'text leading text-link-1 pc:hover:opacity-80 pc:hover:ease-in-out pc:hover:duration-300',
            rel: 'noreferrer',
          },
          line,
        );
      }

      return line;
    });
  });
};
